import { APIClient } from "../api";

export default class WorkTypeService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getWorkType(WorkGroupTypeId: number) {
        const url = `${this.endpoint}/WorkType?$filter=(IdWorkGroupType eq ${WorkGroupTypeId} and Disabled eq 0)`;

        if (WorkGroupTypeId == 0) {
            return;
        }
        
        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async GetWorkTypes(WorkGroupTypeId: number) {
        const url = `${this.endpoint}/WorkType/GetWorkTypes/${WorkGroupTypeId}`;

        if (WorkGroupTypeId == 0) {
            return;
        }
        
        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async getWorkGroupType(BusinessAreaId: number) {
        const url = `${this.endpoint}/WorkGroupType?$filter=(IdBusinessArea eq ${BusinessAreaId} and Disabled eq 0)`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async getAllByServiceId(serviceId: number) {
        const url = `${this.endpoint}/WorkGroupType/GetAllByServiceId/${serviceId}`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async GetNextWorks(WorkTypeId: number) {
        const url = `${this.endpoint}/WorkType/GetNextWorks/${WorkTypeId}`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }
}